/* Moved out of sections/category-nav.liquid (was an inline <script> there), loaded with defer. */
  /* Smart dropdown alignment — flips each megamenu to right-anchored when
     it would otherwise overflow the viewport's right edge. Runs once per
     dropdown on first hover/focus (cached after that), and re-runs on
     window resize / orientation change. Pure progressive enhancement —
     the CSS default (left: 0) still works if JS fails. */
  (function () {
    var items = document.querySelectorAll('.category-nav__item--has-children');
    if (!items.length) return;

    function checkAlignment(item) {
      var menu = item.querySelector('.category-nav__megamenu');
      if (!menu) return;
      /* Menu uses visibility:hidden + opacity:0 (not display:none) so it
         stays in layout and is directly measurable, no toggling needed. */
      menu.classList.remove('is-right-aligned');
      var rect = menu.getBoundingClientRect();
      var overflowRight = rect.right > (window.innerWidth - 8);
      if (overflowRight) menu.classList.add('is-right-aligned');
    }

    /* Run on initial load (once images / fonts have settled the layout) */
    function checkAll() { items.forEach(checkAlignment); }
    if (document.readyState === 'complete') checkAll();
    else window.addEventListener('load', checkAll);

    /* Re-check whenever the viewport changes width (resize, orientation). */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkAll, 120);
    });

    /* Belt and braces: re-check on first hover/focus of each item too, in
       case layout changed between load and interaction (e.g. lazy-loaded
       content above the nav). */
    items.forEach(function (item) {
      var checked = false;
      var handler = function () {
        if (checked) return;
        checked = true;
        checkAlignment(item);
      };
      item.addEventListener('mouseenter', handler);
      item.addEventListener('focusin',    handler);
    });
  })();

  (function () {
    var drawer = document.querySelector('[data-cat-nav-drawer]');
    /* Every button that opens the menu: the burger in the main header row
       (main-nav.liquid) and this bar's own burger. */
    var toggles = document.querySelectorAll('[data-cat-nav-toggle]');
    if (!drawer || !toggles.length) return;
    var lastFocused = null;
    function setExpanded(value) {
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', value); });
    }

    function open() {
      lastFocused = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      setExpanded('true');
      /* Scroll lock via body class instead of inline `overflow: hidden`.
         The reason: setting `body { overflow: hidden }` removes the body
         as the page's scroll container, which silently breaks every
         descendant `position: sticky` — including the main-nav. Result
         was the nav scrolled off-screen and the drawer's backdrop made
         it look like the nav had vanished entirely (reported visually
         on mobile screenshots).

         The body class drives a small style block (set in the section's
         <style> block above) that locks scroll AND pins `.main-nav` as
         `position: fixed` so it stays at the viewport top while the
         drawer is open. Closing reverses both in one step. */
      document.body.classList.add('is-cat-drawer-open');
      setTimeout(function () {
        var firstLink = drawer.querySelector('a, button');
        if (firstLink) firstLink.focus();
      }, 50);
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      setExpanded('false');
      document.body.classList.remove('is-cat-drawer-open');
      if (lastFocused) lastFocused.focus();
    }

    toggles.forEach(function (t) { t.addEventListener('click', open); });
    drawer.querySelectorAll('[data-cat-nav-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    /* Focus trap — keeps Tab / Shift+Tab inside the open drawer so a
       keyboard or screen-reader user can't tab out into the page behind
       it (WCAG 2.4.3). Mirrors the cart drawer's behaviour. Only active
       while the drawer is open; when closed the handler bails immediately
       so it costs nothing. */
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (drawer.getAttribute('aria-hidden') !== 'false') return;

      var focusables = drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      );
      /* Only visible elements participate (drawer groups can be collapsed). */
      focusables = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null;
      });
      if (!focusables.length) return;

      var first = focusables[0];
      var last  = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  })();
    (function () {
    /* Megamenu focus-clear — fixes the "two dropdowns open at once" bug.
       Clicking a trigger gives it focus, which keeps its dropdown open
       via :focus-within. Hovering a sibling then opens its dropdown via
       :hover, leaving both visible. This handler blurs the previously-
       focused trigger as soon as the cursor enters a different one,
       ensuring only one dropdown is open at a time. Keyboard nav is
       untouched — Tab still moves focus and reveals dropdowns normally. */
    var items = document.querySelectorAll('.category-nav__item--has-children');
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var active = document.activeElement;
        if (!active || active === document.body) return;
        var otherTrigger = active.closest('.category-nav__item--has-children');
        if (otherTrigger && otherTrigger !== item) active.blur();
      });
    });
  })();
